import { Autocomplete, Stack, TextField } from "@mui/material";
import React from "react";
import { calibrationStatusOptions, comBrandOptions, ecuTypeOptions, injectorOptions, renderCalibrationStatusOption, renderComBrandOption, renderEcuTypeOption } from "../_Utils/AppDocuCommon";

/**
 * CalibrationDialogForm - Form comune per AddCalibrationDialog e EditCalibrationDialog
 * Props:
 *   itemData: oggetto dati calibrazione
 *   onChange: funzione (nuovoItemData) => void
 *   disabled: boolean (opzionale)
 */
export default function CalibrationDialogForm({ itemData, onChange, disabled, hideOriginalFilename }) {
  return (
    <Stack spacing={2}>
      {!hideOriginalFilename && (
        <TextField fullWidth label="File Name" value={itemData.original_filename || ''} onChange={e => onChange({ ...itemData, original_filename: e.target.value })} disabled={disabled} />
      )}
      <TextField fullWidth label="Name" value={itemData.name || ''} onChange={e => onChange({ ...itemData, name: e.target.value })} disabled={disabled} />
      <Autocomplete
        freeSolo
        fullWidth
        options={comBrandOptions.map(opt => opt.name)}
        value={itemData.com_brand || ''}
        onChange={(_, newValue) => onChange({ ...itemData, com_brand: newValue || '' })}
        onInputChange={(_, newInputValue) => onChange({ ...itemData, com_brand: newInputValue })}
        renderOption={renderComBrandOption}
        renderInput={(params) => <TextField {...params} label="Com Brand" disabled={disabled} />}
        disableClearable
        autoHighlight
      />
      <Autocomplete
        freeSolo
        fullWidth
        options={ecuTypeOptions.map(opt => opt.name)}
        value={itemData.ecu_type || ''}
        onChange={(_, newValue) => onChange({ ...itemData, ecu_type: newValue || '' })}
        onInputChange={(_, newInputValue) => onChange({ ...itemData, ecu_type: newInputValue })}
        renderOption={renderEcuTypeOption}
        renderInput={(params) => <TextField {...params} label="ECU Type" disabled={disabled} />}
        disableClearable
        autoHighlight
      />
      <Autocomplete
        freeSolo
        options={injectorOptions}
        value={itemData.injector || ''}
        onInputChange={(_, newValue) => onChange({ ...itemData, injector: newValue })}
        renderInput={(params) => (<TextField {...params} fullWidth label="Injector" disabled={disabled} />)}
      />
      <TextField fullWidth label="FW Version" value={itemData.fw_version || ''} onChange={e => onChange({ ...itemData, fw_version: e.target.value })} disabled={disabled} />
      <TextField fullWidth label="SW Version" value={itemData.sw_version || ''} onChange={e => onChange({ ...itemData, sw_version: e.target.value })} disabled={disabled} />
      <TextField
        fullWidth
        label="Usage info"
        value={itemData.usage_info || ''}
        onChange={e => onChange({ ...itemData, usage_info: e.target.value })}
        multiline
        minRows={3}
        disabled={disabled}
      />
      <Autocomplete
        freeSolo
        options={calibrationStatusOptions.map(opt => opt.name)}
        value={itemData.status || ''}
        onInputChange={(_, newValue) => onChange({ ...itemData, status: newValue })}
        renderOption={renderCalibrationStatusOption}
        renderInput={(params) => (<TextField {...params} fullWidth label="Status" disabled={disabled} />)}
      />
    </Stack>
  );
}
